import React, { useEffect, useState } from "react";
import apiClient from "../../services/apiClient";

const AdminCategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [newCategoryCode, setNewCategoryCode] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiClient.get("/api/admin/categories");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleAddCategory = async () => {
    try {
      await apiClient.post("/api/admin/categories", { name: newCategory });
      setNewCategory("");
      // Optionally, refetch categories to update the list
    } catch (error) {
      console.error("Error adding category:", error);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Category Management</h1>
      <div className="mb-4">
        <div>
          <label>New Category Name</label>
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="New Category Name"
            className="border p-2 mb-2 ml-2"
          />
        </div>
        <div>
          <label>New Category Code</label>
          <input
            type="text"
            value={newCategoryCode}
            onChange={(e) => setNewCategoryCode(e.target.value)}
            placeholder="New Category Code"
            className="border p-2 mb-2 ml-2"
          />
        </div>

        <button onClick={handleAddCategory} className="bg-blue-500 text-white p-2 rounded">
          Add Category
        </button>
      </div>
      <h2 className="text-xl">Existing Categories</h2>
      <ul>
        {categories.map((category) => (
          <li key={category.id}>{category.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default AdminCategoryManagement;
